import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { AccountsApi } from '@shared/api/rest';
import { useNotificationStore } from '../misc';
import { Constants } from '@shared/widgets';
import { AddAccountRequest } from '@shared/api/rest/accounts';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface addAccountType {
  error: string | null;
  success: boolean | null;
  loading: boolean;
  create: (request: AddAccountRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useAddAccountStore = create<addAccountType>((set) => ({
  error: null,
  success: false,
  loading: false,

  create: ApiUtils.wrapperApi(async (request) => {
    try {
      set({ loading: true, success: null, error: null });
      await AccountsApi.addAccount(request);
      set({ success: true, loading: false });
      useNotificationStore.getState().setSuccess(Constants.DEFAULT_SUCCESS_MESSAGE);
    } catch (error) {
      set({ success: null, error: ApiUtils.getApiError(error), loading: false });
      useNotificationStore.getState().setError(Constants.DEFAULT_ERROR_MESSAGE);
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ error: null, success: false, loading: false }),
}));
